import { Injectable } from '@angular/core';
import { CommonService } from '../../service/common.service'
import { NoiseDropLineParam } from './noise-dropbox-line-interface';
import * as _ from 'lodash';

import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as legend from '../../config/legend';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as series from '../../config/series';
import * as grid from '../../config/grid';
import * as brush from '../../config/brush';

type axisLabelRotate = 'leftSmallAngle' | 'leftBigAngle' | 'rightSmallAngle' | 'rightBigAngle';

@Injectable({
  providedIn: 'root'
})
export class NoiseDropboxLineService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.setNoiseDropboxLine();


  //todo 获取默认option
  getDefaultOpitonsOfNoiseDropLineChart = () => {

    let chartOpt = {
      backgroundColor: backgroundColor.backgroundColor,
      grid: this.style.grid,
      toolbox: {
        show: true,
        itemGap: this.style.toolbox.itemGap,
        showTitle: true,
        right: this.style.toolbox.right, // 右边距 
        top: this.style.toolbox.top, // 上边距
        itemSize: this.style.toolbox.itemSize, //工具栏 icon 的大小
      },
      legend: legend.getNoiseDropLineLegend(this.style, []),
      tooltip: tooltip.getNoiseDropLineTooltip(),
      xAxis: xAxis.getXaxisOfNoiseDropLine([], ''),
      yAxis: yAxis.getYaxisOfNoiseDropLine(""),
      series: series.getBasicLineChartSeriesWithoutData()
    }
    return chartOpt
  }




  //todo 更改toolbox显示项目
  changeToolboxItem(chartOpt, dropToolboxData, funcObj) {
    if (dropToolboxData.toolboxItem && dropToolboxData.toolboxItem.includes('brush')) {
      chartOpt.brush = brush.getNoiseAnalysisLineXBrush()
    }
    chartOpt.toolbox.feature = toolbox.getNoiseDropboxLineToolbox(this.style, dropToolboxData, funcObj).feature;
    return chartOpt
  }



  //todo tooltip显示格式化
  setTooltipFormat(value: string) {
    return tooltip.getNoiseDropLineTooltip(value);
  }

  //todo 更改chartData
  changeChartData(chartOpt, data: NoiseDropLineParam) {
    let legenddata = new Set(data.seriesDatas.map((item) => {
      return item.name
    }))
    if (data.toolboxDatas 
      && data.toolboxDatas.toolboxItem
      && data.toolboxDatas.toolboxItem.includes('switchSingleChoice')
      && data.toolboxDatas.singleChoiceData) {
      const singleobj = data.toolboxDatas.singleChoiceData
      singleobj.map((item) => {
        if (item.ischecked && item.yAxisName) {
          const yAxisName = item.yAxisName
          chartOpt.yAxis[0].name = yAxis.getYaxisOfNoiseDropLine(yAxisName)[0].name
        }
      })
    }
    if (data.toolboxDatas 
      && data.toolboxDatas.toolboxItem
      && data.toolboxDatas.toolboxItem.includes('switchInterval')
      && data.toolboxDatas.xIntervalData) {
      const intervalDataobj = data.toolboxDatas.xIntervalData
      intervalDataobj.map((item) => {
        if (item.ischecked) {
          const interval = item.value
          chartOpt.xAxis[0].axisLabel.interval = Number(interval)
        }
      })
    }
    chartOpt.legend = legend.getNoiseDropLineLegend(this.style, legenddata)
    chartOpt.xAxis[0].data = xAxis.getXaxisOfNoiseDropLine(data.xAxisDatas)[0].data
    if (data.xFormatter) {
      chartOpt.xAxis[0].axisLabel.formatter = xAxis.getXaxisOfNoiseDropLine(data.xAxisDatas, data.xFormatter)[0].axisLabel.formatter
    }
    chartOpt.series = series.geSeriesOfNoiseDropLine(data)
    return chartOpt
  }


}
